import request from '@/utils/request'
import { withErpOpenApiAction } from '@/utils/erpOpenApiContext'

const baseUrl = '/erp/product'

/** 华住相关操作：页面用 $message 展示后端返回，避免与全局 notification 重复且被遮挡。 */
function huazhuOpRequest (action, config) {
  const headers = Object.assign({}, (config && config.headers) || {}, { skipGlobalErrorNotify: true })
  return withErpOpenApiAction(action, Object.assign({}, config, { headers }))
}

/** 商品分页列表 */
export function pageProduct (query) {
  return request({
    url: baseUrl + '/page',
    method: 'get',
    params: query
  })
}

/** 商品详情（含 SKU / 财税 / MOQ） */
export function getProduct (id) {
  return request({
    url: baseUrl + '/detail',
    method: 'get',
    params: { id }
  })
}

/** 批量修改品牌、状态或基本单位 */
export function batchEditProduct (data) {
  const action = data && (data.status === 'disabled' || data.status === '停用') ? '批量停用SPU'
    : (data && (data.status === 'enabled' || data.status === '启用') ? '批量启用SPU' : '批量编辑商品')
  const req = (action === '批量停用SPU' || action === '批量启用SPU')
    ? huazhuOpRequest(action, { url: baseUrl + '/batch-edit', method: 'post', data })
    : withErpOpenApiAction(action, { url: baseUrl + '/batch-edit', method: 'post', data })
  return request(req)
}

/** 批量同步未同步商品到华住（外部接口待接入） */
export function batchSyncHuazhuProduct (data) {
  return request(huazhuOpRequest('同步华住商城', {
    url: baseUrl + '/batch-sync-huazhu',
    method: 'post',
    data
  }))
}

/** 导入商品 */
export function importProduct (data) {
  return request({
    url: baseUrl + '/import',
    method: 'post',
    data,
    timeout: 600000,
    // 不要手动写 multipart/form-data，否则缺少 boundary，服务端可能解析失败
    headers: { 'Content-Type': undefined }
  })
}

/** 新建商品 */
export function createProduct (data) {
  return request({
    url: baseUrl + '/add',
    method: 'post',
    data
  })
}

/** 上传商品图片、视频或检测报告 */
export function uploadProductAttachment (data) {
  return request({
    url: baseUrl + '/attachment/upload',
    method: 'post',
    data,
    // FormData 不参与 JSON 重复提交判断；否则连续上传两个不同文件会都被序列化为 {} 而被误拦截。
    headers: { 'Content-Type': 'multipart/form-data', repeatSubmit: false }
  })
}

/** 编辑商品 */
export function updateProduct (data) {
  return request({
    url: baseUrl + '/edit',
    method: 'post',
    data
  })
}

/** 删除商品 */
export function deleteProduct (id) {
  return request(huazhuOpRequest('删除SPU', {
    url: baseUrl + '/delete',
    method: 'post',
    data: { id }
  }))
}

/** 启用 SPU */
export function enableProduct (id) {
  return request(huazhuOpRequest('启用SPU', {
    url: baseUrl + '/enable',
    method: 'post',
    data: { id }
  }))
}

/** 停用 SPU（下属 SKU 同步停用） */
export function disableProduct (id) {
  return request(huazhuOpRequest('停用SPU', {
    url: baseUrl + '/disable',
    method: 'post',
    data: { id }
  }))
}

/** 批量启用 SPU（一次华住 sync，body.spu_id 逗号拼接） */
export function batchEnableProduct (data) {
  return request(huazhuOpRequest('批量启用SPU', {
    url: baseUrl + '/batch-enable',
    method: 'post',
    data
  }))
}

/** 批量停用 SPU（一次华住 sync） */
export function batchDisableProduct (data) {
  return request(huazhuOpRequest('批量停用SPU', {
    url: baseUrl + '/batch-disable',
    method: 'post',
    data
  }))
}

/** 批量删除 SPU（一次华住 sync） */
export function batchDeleteProduct (data) {
  return request(huazhuOpRequest('批量删除SPU', {
    url: baseUrl + '/batch-delete',
    method: 'post',
    data
  }))
}

/** 启用 SKU（不影响 SPU） */
export function enableSku (id) {
  return request(huazhuOpRequest('启用SKU', {
    url: baseUrl + '/sku/enable',
    method: 'post',
    data: { id }
  }))
}

/** 停用 SKU（不影响 SPU） */
export function disableSku (id) {
  return request(huazhuOpRequest('停用SKU', {
    url: baseUrl + '/sku/disable',
    method: 'post',
    data: { id }
  }))
}

/** 商品分类树（启用） */
export function categoryTreeProduct () {
  return request({
    url: baseUrl + '/category-tree',
    method: 'get'
  })
}

/** 条形码查重（true=可用） */
export function checkBarcode (params) {
  return request({
    url: baseUrl + '/check-barcode',
    method: 'get',
    params
  })
}

/** SPU 编码查重 */
export function checkSpuCode (params) {
  return request({
    url: baseUrl + '/check-spu-code',
    method: 'get',
    params
  })
}

/** 自定义编码查重 */
export function checkCustomCode (params) {
  return request({
    url: baseUrl + '/check-custom-code',
    method: 'get',
    params
  })
}

/** SKU 编码查重 */
export function checkSkuCode (params) {
  return request({
    url: baseUrl + '/check-sku-code',
    method: 'get',
    params
  })
}
